import { render } from "./GlobalStats.vue?vue&type=template&id=44f58c36"
import script from "./GlobalStats.vue?vue&type=script&lang=js"
export * from "./GlobalStats.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__